var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SiteMenuFlyoutLayout",
    {
      attrs: { heading: _vm.heading },
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "ul",
        { staticClass: "text-sm font-semibold uppercase space-y-5" },
        _vm._l(_vm.items, function (item, itemKey) {
          return _c("li", { key: itemKey }, [
            _c(
              "a",
              {
                staticClass: "inline-flex items-center gap-x-2.5",
                attrs: { href: item.link.url, target: item.link.target },
              },
              [
                _vm._v("\n        " + _vm._s(item.link.text) + "\n        "),
                _c("div", { staticClass: "w-4" }, [_c("IconArrowRight")], 1),
              ]
            ),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("InlineSvg", {
        staticClass:
          "h-full w-auto m-auto absolute top-0 left-1/2 -z-10 transform -translate-x-1/2 rotate-16",
        attrs: {
          src: _vm.backgroundImage.url,
          "transform-source": _vm.removeSvgFill,
          fill: _vm.backgroundImageColour,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }